import { useDeleteSession } from "@vega-api/generated/session-v1/session-v1";
import { ThemedButton } from "@vega-core/components/Buttons/ThemedButton";
import { ValidationErrorText } from "@vega-core/components/Form/Layout/ValidationError";
import { m } from "@vega-core/paraglide/messages";

import { CommonPaths } from "../../paths";

export const LocalSessionLogoutButton = () => {
  const { mutate, isPending, error, reset } = useDeleteSession({
    mutation: {
      onSuccess: () => {
        window.location.assign(CommonPaths.Login);
      },
    },
    // Skip auth/retry interceptors so 401 errors surface directly to onError
    // instead of being hijacked by the errorInterceptor's redirect logic
    request: { skipInterceptors: true },
  });

  const errorMessage = error
    ? (error.response?.data?.message ?? m.localLogin_unexpectedError())
    : null;

  const handleClick = () => {
    reset();
    mutate();
  };

  return (
    <>
      <ThemedButton
        dataTestId="local-session-logout-button"
        disabled={isPending}
        fullWidth
        onClick={handleClick}
        variant="secondary"
      >
        {isPending ? m.localLogin_signingOut() : m.localLogin_signOutButton()}
      </ThemedButton>
      {errorMessage ? (
        <div className="mt-2">
          <ValidationErrorText dataTestId="local-session-logout">
            {errorMessage}
          </ValidationErrorText>
        </div>
      ) : null}
    </>
  );
};
